import { requset } from './request'
/**
 * 提交方法
 * @param {*} params
 * @param {*} actions
 * @returns
 */
export async function submit(params, actions) {
  const errors = await actions.validate?.()
  if (errors) {
    Array.isArray(errors) && actions.updateTopErrors?.({ errors })
    return Promise.reject()
  }
  const requestParams = {
    property: {
      form: true,
      confirm: true,
      confirmOption: {
        message: '确认提交',
      },
      successTip: 'message',
      ...params.property,
    },
    parameter: params.parameter,
  }
  return requset(requestParams, actions)
}
